
import { AdPlacementsComponentTypes } from '@bingads-webui-campaign-react/ad-placement-consts';

const windowsSpotlight = {
  componentType: AdPlacementsComponentTypes.AdPlacementPreview,
  aspectRatio: 1.9,
  type: 'Image191x100',
  className: 'boost-windows',
  associationType: 'LandscapeImageMedia',
  stringKey: 'ImageExperience_Image_Ratio_191x100',
  imagePreviewHeight: 250,
  simplifiedType: 'Image191x100',
  isRequired: true,
  minimumRequirements: 1,
  minSize: [268, 140],
  localizedText: {
    previewTypeStringKey: _TL_('Windows Spotlight'),
    stringKey: _TL_('Windows Spotlight'),
  },
  previewSettings: {
    showLongHeadline: true,
    showBusinessName: false,
    multipleLineLongHeadline: true,
    multipleDescription: true,
    showDescription: true,
    hideLabel: true,
    showHotspots: true,
    showBoostWindows: true,
    showImage: true,
  },
  styleOverrides: {
    cardParent: {
      '& .hardcode-time': {
        flexDirection: 'column',
        alignItems: 'center',
        position: 'absolute',
        display: 'flex',
        justifyContent: 'space-between',
        top: 20,
        left: '50%',
        color: 'white',
        transform: 'translate(-50%)',
        '& .welcome': {
          marginBottom: 10,
        },
        '& .time': {
          fontSize: 40,
        },
      },
      '& .text-container-apl': {
        display: 'flex',
        right: 50,
        top: 20,
        color: 'white',
        bottom: 'unset',
        left: 'unset',
        padding: 10,
        fontSize: 8,
        position: 'absolute',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: 65,
        height: 65,
        backgroundColor: '#272a14',
        opacity: 0.8,
        borderRadius: 5,
      },
      '& .hotspot0': {
        position: 'absolute',
        color: 'white',
        top: 20,
        left: 80,
        display: 'flex',
        padding: 10,
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: 130,
        height: 130,
        fontSize: 8,
        backgroundColor: '#272a14',
        opacity: 0.8,
        borderRadius: 5,
        '& .hotspot-action': {
          marginTop: 10,
          curosr: 'pointer',
        },
      },
      '& .hotspot1': {
        position: 'absolute',
        color: 'white',
        top: '50%',
        left: '50%',
        padding: 10,
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: 130,
        height: 130,
        fontSize: 8,
        backgroundColor: '#272a14',
        opacity: 0.8,
        borderRadius: 5,
        '& .hotspot-action': {
          marginTop: 10,
          curosr: 'pointer',
        },
      },
      '& .hotspot2': {
        position: 'absolute',
        color: 'white',
        top: 250,
        right: 80,
        padding: 10,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: 130,
        height: 130,
        fontSize: 8,
        backgroundColor: '#272a14',
        opacity: 0.8,
        borderRadius: 5,
        '& .hotspot-action': {
          marginTop: 10,
          curosr: 'pointer',
        },
      },
    },
  },
};

export default windowsSpotlight;

